export const diStrategy = {
  title: '適異教學策略',
  diStrategyClassLabel: '{{label}}. {{name}}',
  diStrategyLabel:
    '{{diStrategyClassLabel}}{{diStrategyLabelNumber}}. {{diStrategyName}}',
  tags: '對應的特質',
  video: '適異教學課堂短片',
  furtherReadingAndExamples: '示例及延伸閱讀',
}
